/**
 * Appearance section of the role create/edit form.
 */
import { Palette } from 'lucide-react';
import { IconPicker } from '@/components/forms/IconPicker';
import { ColorPicker } from '@/components/forms/ColorPicker';
import type { RoleFormState } from '@/types/role.types';

/** Props for {@link RoleAppearanceSection}. */
interface RoleAppearanceSectionProps {
  form: RoleFormState;
  onChange: (field: keyof RoleFormState, value: unknown) => void;
}

/** Appearance section of the role create/edit form. */
export function RoleAppearanceSection({ form, onChange }: Readonly<RoleAppearanceSectionProps>) {
  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <Palette className="w-4 h-4" />
        Apparence
      </h4>
      <div className="grid grid-cols-2 gap-4">
        <div className="form-field">
          <p className="form-label">Icône</p>
          <IconPicker value={form.icon || null} onChange={(icon) => onChange('icon', icon)} />
        </div>
        <div className="form-field">
          <p className="form-label">Couleur</p>
          <ColorPicker value={form.color || null} onChange={(color) => onChange('color', color)} />
        </div>
      </div>
    </div>
  );
}
